export const AVATAR: string = "avatar";
export const CLIENT_ID: string = "Client-ID";
export const I18NEXTLNG: string = "i18nextLng";
export const LANGUAGE: string = 'language';
export const LANGUAGE_ID: string = 'languageId';
export const LOCAL_STORAGE_START = 'timer_start';
export const LOCAL_STORAGE_DURATION = 'timer_duration';
export const LOCAL_STORAGE_COMPANY_GROUPS = 'companyGroups';
export const LOCAL_STORAGE_COMPANY_PAYMENT = 'companyPayment';
export const LOCAL_STORAGE_USER_DATA = 'userData';
export const COMPANY_PAYMENT_VIEWED = 'companyPaymentViewed';